
export default [
  {
    name:"Rep",
    path: '/Rep/index',
    component: (resolve) => require(['@/views/Rep/index'], resolve),
    meta: { title: 'Rep Detailed', noCache: false, affix: false },
    roles:[0,9]
  },
  
]
